<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/img/toplogo_jiegui.png" alt />
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/goin">公司介绍</el-menu-item>
          <el-menu-item index="/case">业绩案例</el-menu-item>
          <el-menu-item index="/news">企业动态</el-menu-item>
          <el-menu-item index="/project">项目入口</el-menu-item>
          <el-menu-item index="/Download">下载入口</el-menu-item>
        </el-menu>
        
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="false">
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: arial, "microsoft yahei" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-menu-demo li{
  font-size:22px;
  font-family: arial, "microsoft yahei" !important;
}
.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 216px;
  overflow: hidden;
  background-color: #14679f;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
.display-none{
  display: none;
}
@media screen and (max-width: 600px) { /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
  .el-header {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-evenly;
      -ms-flex-line-pack: center;
      align-content: stretch;
      width: 100%;
      margin: auto;
      padding: 0 0px;
      flex-direction: column;
      flex-wrap: wrap;
      align-items: center;
  }
  .el-header .logo {
    width: 280px;
    margin: auto 0px;
    padding: 0px;
    display: none;
  }
  .el-menu-demo{
    display: none;
  }
  
  .display-none{
    display:block;
  }
  .el-menu-item{
    padding: 0 10px
  }
}
</style>
